module API.RecentForms where

import Common

import API.FormBase (FormBasic, FormID)
import API.Export (ExportType)
import API.Pagination (Page)
import API.Search (BaseSearchQuery, queryObj', queryVars)
import API.SelStudent (SelStudent)
import API.Types (DocumentID)
import Data.Argonaut as J
import Foreign.Object as O
import GraphQL.Query (class ToVars, Query, QueryVar(..), buildQuery, nameQuery, toVars)
import GraphQL.Type (QType(..))
import Internal.Luxon (LDateTime)
import Widgets.Signature.Types (DocSigField, SignKey)

type RecentForm =
    { id :: DocumentID
    , form_type :: FormBasic
    , student :: SelStudent
    , subtitle :: String
    , updated_at :: String
    , locked_at :: Maybe LDateTime
    , legacy_url :: Maybe String
    , exports :: Array ExportType
    , signatures :: Array { key :: SignKey }
    , signature_fields :: Array DocSigField
    , employer :: Maybe { company :: String }
    , contact :: Maybe { name :: String }
    -- In order to display comment count we need to load at least one field
    -- from the comments so we can count them. Loading the created time could
    -- allow us to show when the latest comment was posted if we want to later
    -- anyway.
    , verifications :: Array { created_at :: LDateTime, data :: { key :: SignKey, email :: String } }
    , comments :: Array { created_at :: LDateTime }
    -- Same for attachments
    , attachments :: Array { created_at :: LDateTime }
    , can :: { lock :: Boolean, update :: Boolean }
    }

emptyFormQuery :: FormSearchQuery
emptyFormQuery = FormSearchQuery
    { teacher: Nothing
    , semester: Nothing
    , search: Nothing
    , class: Nothing
    , formIds: []
    }

data FormSearchQuery = FormSearchQuery (BaseSearchQuery ( formIds :: Array FormID ) )

instance ToVars FormSearchQuery where
    toVars (FormSearchQuery q@{formIds: []}) = toVars $ queryVars q
    toVars (FormSearchQuery q) = (toVars $ queryVars q) <> [ QueryVar "type_id" (ArrayOf $ QType "ID") ]

    encodeVars (FormSearchQuery q@{formIds: []}) = queryObj' q
    encodeVars (FormSearchQuery q@{formIds: fids}) = 
        O.insert "type_id" (J.fromArray $ map encodeJson fids) $ queryObj' q

    varFiles _ = []

searchRecentForms :: FormSearchQuery -> Query (Page RecentForm)
searchRecentForms = nameQuery "RecentForms" <<< buildQuery "recentForms"

fetchRecentFormsByIds :: Array DocumentID -> Query (Array RecentForm)
fetchRecentFormsByIds ids =
    nameQuery "RecentFormsByIds" $
        _.forms <$> (buildQuery "forms" { ids } :: Query { forms :: Array RecentForm })

fetchRecentFormById :: DocumentID -> Query RecentForm
fetchRecentFormById id = nameQuery "RecentForm" $ buildQuery "form" { id }
